<template>
  <h1 class="title has-text-centered is-spaced">
    <go-to-dashboard-button />

    {{ $t("buyNowPayLater.buyNowPayLater") }}
    <span v-show="!c1 && !c2">&nbsp;</span>

    <br v-show="c1" />

    <button
      class="button"
      @click="$emit('get-buy-now-pay-later')"
      :style="c1 ? 'margin-top: 1rem;' : ''"
    >
      <b-icon icon="sync-alt"></b-icon>
    </button>

    <hr />
  </h1>
</template>

<script>
import { responsive } from "../../mixins/responsive";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  mixins: [responsive],

  components: {
    goToDashboardButton
  },

  computed: {
    c1() {
      return this.windowWidth < 700;
    },

    c2() {
      return this.windowWidth < 370;
    }
  }
};
</script>

<style scoped>
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
